<nb-card>
  <nb-card-header [ngClass]="{'header-loading': loading}">
    <div #headerContainer class="row m-0 d-flex headerContainer">
      @if (dateFiltering) {
        <div class="headerTool dateFilter me-2" style="width: 245px; min-width: 245px;">
          <input
            #dateInput
            nbInput
            [nbDatepicker]="datePicker"
            placeholder="{{ dateRange && !noDateFilters? (dateRange.start | date: 'MM/dd/yy') + ' - ' + (dateRange.end | date: 'MM/dd/yy') :
              optionalDateFiltering ? 'Filter by Date Range' : 'Today' }}"
            (change)="enableClearDates($event)"
            [disabled]="disableDateFilter"
            />
          @if (!noDateFilters && !dateInput.disabled) {
            <nb-icon class="clearButton" nbSuffix [icon]="'close-circle-outline'" (click)="clearDates()" [disabled]="true"> </nb-icon>
          }
          @if (noDateFilters && !dateInput.disabled) {
            <nb-icon class="searchIcon" nbSuffix [icon]="'search-outline'"> </nb-icon>
          }
          <nb-rangepicker #datePicker (rangeChange)="handleRangeChange($event)" [range]="dateRange" [min]="minAllowedDate" [max]="maxAllowedDate" format="MM/dd/yy"> </nb-rangepicker>
        </div>
      }
      @if (dateTimeFiltering) {
        <div class="headerTool dateTimeFilter me-2">
          <div class="position-relative me-1">
            <input #startDatetimeInput nbInput id="from" placeholder="Start Datetime" [nbDatepicker]="startDatetimePicker" [disabled]="disableDateFilter"
              [status]="!validDateRange && datetimeRange.end ? 'danger' : 'basic'" [(ngModel)]="datetimeRange.start">
            @if (startDatetimeInput.value) {
              <nb-icon class="clearButton" nbSuffix [icon]="'close-circle-outline'" (click)="clearStartDatetime()" [class.disabled]="disableDateFilter"> </nb-icon>
            }
            @if (!startDatetimeInput.value) {
              <nb-icon class="searchIcon" nbSuffix [icon]="'search-outline'"> </nb-icon>
            }
            <nb-date-timepicker #startDatetimePicker [min]="minAllowedDate" [max]="nowDatetime" (dateTimeChange)="setStartDatetime($event)" format="MM/dd/yy HH:mm"></nb-date-timepicker>
          </div>
          <div class="position-relative">
            <input #endDatetimeInput nbInput id="to" placeholder="End Datetime" [nbDatepicker]="endDatetimePicker" [disabled]="!datetimeRange.start || disableDateFilter"
              [status]="validDateRange ? 'basic' : 'danger'" [(ngModel)]="datetimeRange.end">
            @if (endDatetimeInput.value) {
              <nb-icon class="clearButton" nbSuffix [icon]="'close-circle-outline'" (click)="clearEndDatetime()" [class.disabled]="disableDateFilter"> </nb-icon>
            }
            @if (!endDatetimeInput.value) {
              <nb-icon class="searchIcon" nbSuffix [icon]="'search-outline'"> </nb-icon>
            }
            <nb-date-timepicker #endDatetimePicker [max]="maxAllowedDate" (dateTimeChange)="setEndDatetime($event)" format="MM/dd/yy HH:mm"></nb-date-timepicker>
          </div>
        </div>
      }
      @if (searchable) {
        <div class="headerTool searchContainer col-9 col-sm-6 col-md-6 col-lg-4">
          <input nbInput fullWidth class="search-input col" type="text" placeholder="Search" name="searchTerm" [(ngModel)]="searchTerm" (keyup)="searchByEnter($event)" clear />
          @if (searchTerm && searchTerm !== ' ') {
            <nb-icon class="clearButton" nbSuffix [icon]="'close-circle-outline'" (click)="cleanInput()"></nb-icon>
          }
          @if (!searchTerm) {
            <nb-icon class="searchIcon" nbSuffix [icon]="'search-outline'"> </nb-icon>
          }
        </div>
      }
      @if (addAction) {
        <div class="headerTool col">
          @if (writePermissions) {
            <button
              id="add-entity-button"
              class="add-entity-button float-end"
              status="primary"
              nbButton
              ghost
              (click)="addAction()"
              >
              ADD NEW
            </button>
          }
        </div>
      }
      @if (exportAction) {
        <div class="headerTool col">
          <button
            class="export-button float-end"
            status="primary"
            nbButton
            ghost
            [disabled]="exporting"
            (click)="exportAction()"
            >
            EXPORT
            @if (!exporting) {
              <nb-icon icon="download-outline"></nb-icon>
            }
            @if (exporting) {
              <i class="fa fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      }
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div #tableContainer class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0 tableContainer">
        <table class="table table-loader">
          <thead class="sticky-header">
            <tr>
              @if (detailsHeaders || detailsCustomRenderer) {
                <th style="width: 40px; min-width: 30px;"></th>
              }
              @for (header of headersList; track header.name) {
                <th
                  appSortable="{{ header.sortName || header.name }}"
                  scope="col"
                  defaultSort="{{ header.sortName === defaultSortHeader || header.name === defaultSortHeader ? '' : false }}"
                  noSortable="{{ header.noSortable || false }}"
                  sortName="{{ header.sortName ? header.sortName : '' }}"
                  defaultDirection="{{ defaultDirection || 'desc' }}"
                  (sort)="onSort($event)"
                  [ngStyle]="header.style ? header.style : ''"
                  [nbTooltipDisabled]="!header.tooltip"
                  [nbTooltip]="header.tooltip"
                  nbTooltipStatus="default"
                  nbTooltipPlacement="bottom"
                  >
                  {{ header.title }}
                  @if (filtersByHeader && filtersByHeader[header.name]) {
                    <nb-icon
                      id="filterIcon"
                      class="filterable"
                      nbPopoverPlacement="bottom"
                      nbPopoverTrigger="click"
                      [nbPopoverContext]="header"
                      [nbPopover]="filterablePopover"
                      icon="plus-circle-outline"
                      (click)="showFilterablePopUp($event, header.name)"
                      >
                    </nb-icon>
                  }
                  @if (header.selectAllColumn) {
                    <nb-checkbox [checked]="selectAllChecked" (checkedChange)="toggleSelectAllRows($event)"></nb-checkbox>
                  }
                </th>
              }
            </tr>
          </thead>
          @if (!loading) {
            <tbody class="loaded_table">
              @for (row of data; track $index; let i = $index) {
                <tr
                  (mousedown)="onMouseDown($event)"
                  (click)="route ? writePermissions ? goDetails($event, row) : false : selectedRow = row.id"
                  [class.highlightRow]="isSelectable && selectedRow === row.id"
                  [ngClass]="row.error ? 'row-with-error' : row.customRowClass ? row.customRowClass : ''"
                  [class]="row.wsUpdateTimestamp ? 'row-updated' : ''"
                  >
                  @if (detailsHeaders || detailsCustomRenderer) {
                    <td>
                      <nb-icon
                        class="detailsIcon"
                        [nbTooltipDisabled]="row.expanded"
                        [nbTooltip]="toggleDetailsTooltip"
                        nbTooltipStatus="default"
                        nbTooltipPlacement="right"
                        [icon]="row.expanded ? 'arrow-ios-downward-outline' : 'arrow-ios-forward-outline'"
                        [ngClass]="{ 'disabled': row.disableDetails }"
                        (click)="showDetails($event, row)"
                        >
                      </nb-icon>
                    </td>
                  }
                  @for (header of headersList; track header.name) {
                    <td
                      [ngStyle]="header.style ? header.style : ''"
                      [ngClass]="header.bodyClass ? ' ' + header.bodyClass : ''"
                      [nbTooltipDisabled]="!row.errorMessage || header.customComponentRender"
                      [nbTooltip]="row.errorMessage"
                      nbTooltipStatus="danger"
                      nbTooltipPlacement="bottom"
                      >
                      @if (!header.badge && !header.customComponentRender) {
                        <ngb-highlight
                          [ngStyle]="checkStyle(row, header)"
                          [term]="searchTerm"
                          [result]="parseHeader(row, header.name)"
                          (dblclick)="copyToClipboard($event)"
                          >
                        </ngb-highlight>
                      }
                      @if (header.badge) {
                        <nb-badge
                          text="{{ parseHeader(row, header.name) }}"
                          status="{{ header.badge[parseHeader(row, header.name)] }}"
                          [nbTooltipDisabled]="!row.statusReason"
                          [nbTooltip]="row.statusReason"
                          nbTooltipStatus="default"
                          nbTooltipPlacement="bottom"
                        ></nb-badge>
                      }
                      @if (header.customComponentRender) {
                        <app-dynamic-component [component]="header.customComponentRender" [data]="parseHeader(row, header.name)">
                        </app-dynamic-component>
                      }
                    </td>
                  }
                </tr>
                @if (detailsHeaders) {
                  <tr class="details" [ngClass]="row.expanded ? 'expanded': 'collapsed'">
                    @if (row.details || loadingDetails) {
                      <td class="detailsContainer" colspan="100">
                        <table class="table detailsTable">
                          <thead>
                            <tr>
                              @for (header of detailsHeaders; track header.name) {
                                <th [ngStyle]="header.style ? header.style : ''">
                                  {{ header.title }}
                                </th>
                              }
                            </tr>
                          </thead>
                          @if (!loadingDetails) {
                            <tbody class="loaded_table">
                              @if (row.details.length) {
                                @for (subRow of row.details; track $index) {
                                  <tr (click)="selectedRowDetail = subRow.id" [class.highlightRow]="isSelectable && selectedRowDetail === subRow.id">
                                    @for (header of detailsHeaders; track header.name) {
                                      <td [ngStyle]="header.style ? header.style : ''">
                                        @if (!header.customComponentRender) {
                                          <span (dblclick)="copyToClipboard($event)">
                                            {{ header.customRender ? header.customRender(subRow, header) : subRow[header.name] }}
                                          </span>
                                        }
                                        @if (header.customComponentRender) {
                                          <app-dynamic-component [component]="header.customComponentRender" [data]="header.customRender(subRow, header)">
                                          </app-dynamic-component>
                                        }
                                      </td>
                                    }
                                  </tr>
                                }
                              } @else {
                                <div class="noDetails">{{ noDetailsDataMessage || 'No Data' }}</div>
                              }
                            </tbody>
                          } @else {
                            <tbody class="loading_table">
                              <div class="spinner">
                                <div class="blob blob-0"></div>
                              </div>
                            </tbody>
                          }
                        </table>
                        @if (paginateDetails) {
                          <div class="pagination-controls">
                            <ngb-pagination
                              id="paginationControls"
                              class="d-flex justify-content-end"
                              [collectionSize]="totalDetailsElements"
                              (page)="detailsPage"
                              (pageChange)="setDetailsPage($event)"
                              [pageSize]="detailsSize"
                              [maxSize]="3"
                              [boundaryLinks]="true"
                              >
                            </ngb-pagination>
                          </div>
                        }
                      </td>
                    }
                  </tr>
                }
                @if (detailsCustomRenderer) {
                  <tr class="details" [ngClass]="row.expanded ? 'expanded': 'collapsed'">
                    @if (row.details || loadingDetails) {
                      <td class="detailsContainer" colspan="100">
                        @if (loadingDetails) {
                          <div class="loading_table">
                            <div class="spinner">
                              <div class="blob blob-0"></div>
                            </div>
                          </div>
                        }
                        @if (!loadingDetails && row.details?.length) {
                          <app-dynamic-component [component]="detailsCustomRenderer" [data]="row.details"></app-dynamic-component>
                        }
                        @if (!loadingDetails && !row.details?.length) {
                          <div class="loaded_table">
                            <div class="noDetails">No Data</div>
                          </div>
                        }
                      </td>
                    }
                  </tr>
                }
              }
              <ng-container>
                @if (!this.data || this.data.length === 0) {
                  <p class="noData">No Data</p>
                }
              </ng-container>
            </tbody>
          } @else {
            <tbody class="loading_table">
              <div class="spinner">
                <div class="blob blob-0"></div>
              </div>
            </tbody>
          }
        </table>
      </div>
    </div>
  </nb-card-body>
  @if (!hidePagination && !loading && data.length) {
    <nb-card-footer>
      <div class="row pagination-controls justify-content-between">
        <div class="col-2 pb-0 ps-0">
          <select id="itemsPerPage" name="size" [(ngModel)]="size" (change)="onItemsSizeChange()">
            <option [ngValue]="10">10 items per page</option>
            <option [ngValue]="20">20 items per page</option>
            <option [ngValue]="50">50 items per page</option>
            <option [ngValue]="100">100 items per page</option>
          </select>
        </div>
        <div class="col-10 pe-0 justify-content-end d-flex">
          @if (subtotals && subtotals.length) {
            @for (subtotal of subtotals; track subtotal.value) {
              <div class="subtotal">
                {{ subtotal.text }}
                <p [ngClass]="subtotal.value.includes('(') ? 'NEGATIVE' : 'POSITIVE'" (dblclick)="copyToClipboard($event)">{{ subtotal.value }}</p>
              </div>
            }
          }
          @if (totalElements !== 100000) {
            <ngb-pagination
              id="paginationControls"
              class="d-flex justify-content-end"
              [collectionSize]="totalElements"
              [(page)]="page"
              (pageChange)="setPage($event)"
              [pageSize]="size"
              [maxSize]="2"
              [boundaryLinks]="true"
              >
            </ngb-pagination>
          }
        </div>
      </div>
    </nb-card-footer>
  }
</nb-card>


<ng-template #filterablePopover>
  @if (showFilterablePopover) {
    <div class="filterPopOver p-2">
      @for (item of filtersByHeader[currentFilterableValue]; track item) {
        <div>
          <nb-checkbox status="basic" (checkedChange)="setFilter(item)" [checked]="filterableInputs[currentFilterableValue].indexOf(item) >= 0">
            {{ item }}
          </nb-checkbox>
        </div>
      }
    </div>
  }
</ng-template>
